import React from 'react';
import PropTypes from 'prop-types';
import DownloadReportButton from '../Reports/DownloadReportButton';
import { DATE_TIME, KPHC_CSN_ID, REPORT_TYPE } from '../../constants/report.constant';
import DownloadPollReportButton from '../PollReport/DownloadPollReportButton';
import { POLL_REPORT_DOWNLOAD_BTN_ICON_CLASS } from '../../constants/polls.constant';
import { DOWNLOAD_POLL_REPORT_PAGE_PATH } from '../../constants/route.constants';

const GroupClassCard = props => {
  const { appointmentCSNId, scheduleDateTime, visitTypeName, zoomMeetingId, actualStartDateTime, zoomMeetingUuid, reportType = REPORT_TYPE.ATTENDEE } = props;

  let downloadButtonProps = {
    btnClass: 'vve-download-icon',
    zoomMeetingId,
    zoomMeetingUuid,
    title: visitTypeName,
    dateTime: actualStartDateTime
  };

  if(reportType === REPORT_TYPE.POLL) {
    downloadButtonProps = {
      btnClass: POLL_REPORT_DOWNLOAD_BTN_ICON_CLASS,
      zoomMeetingUuid,
      pollReportPagePath: DOWNLOAD_POLL_REPORT_PAGE_PATH
    };
  }

  const downloadButtonComponentMap = {
    [REPORT_TYPE.POLL]: DownloadPollReportButton,
    [REPORT_TYPE.ATTENDEE]: DownloadReportButton
  };

  const DownloadButtonComponent = downloadButtonComponentMap[reportType];

  return (
    <div className="vve-groupclass-cards-container">
      <div className="card row vve-card">
        <div className="card-body">
          <h5 className="card-title">{visitTypeName}</h5>
          <div className="card-text row">
            <div className="vve-group-class-text col-md-8 col-sm-8 col-8">
              <span>
                <span className="vve-text-bold">{DATE_TIME}</span>
                {scheduleDateTime}
              </span>
              <br />
              <span className="vve-text-bold">{KPHC_CSN_ID}</span>
              <span>{appointmentCSNId}</span>
            </div>
            <div className="vve-text-right col-md-4 col-sm-4 col-4">
              <DownloadButtonComponent {...downloadButtonProps} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GroupClassCard.propTypes = {
  appointmentCSNId: PropTypes.any,
  scheduleDateTime: PropTypes.string,
  visitTypeName: PropTypes.string,
  zoomMeetingId: PropTypes.any,
  actualStartDateTime: PropTypes.string,
  zoomMeetingUuid: PropTypes.string,
  reportType: PropTypes.oneOf([REPORT_TYPE.POLL, REPORT_TYPE.ATTENDEE])
};

export default GroupClassCard;
